import React from 'react';
import PropTypes from 'prop-types';
import ReactDropdown from 'react-dropdown';
import { DropdownWrapper } from './layout';

export const Dropdown = ({
  id,
  label,
  options,
  value,
  onChange,
  placeholder,
  disabled,
  ...rest
}) => (
  <DropdownWrapper id={id} {...rest}>
    {label && <label>{label}</label>}
    <ReactDropdown
      disabled={disabled}
      options={options}
      value={(value || value === 0) && String(value)}
      onChange={({ value, label }) => onChange(value, label)}
      placeholder={placeholder}
    />
  </DropdownWrapper>
);

Dropdown.propTypes = {
  id: PropTypes.string,
  label: PropTypes.node,
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.any,
      }),
    ]),
  ),
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

Dropdown.defaultProps = {
  options: [],
};



// WEBPACK FOOTER //
// ./components/atoms/Dropdown/Dropdown.js